module.exports = __webpack_public_path__ + "static/media/btn-download-android.4eff248a.png";